import { stateOptions } from '../../../../shared/helper/states'
import AddressSummary from './AddressSummary'

export default {
  components: {
    AddressSummary,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Owner or Contact Person">
      <ui-form-item label="First Name">
        {{ model.contact.firstName }}
      </ui-form-item>

      <ui-form-item label="Middle Name">
        {{ model.contact.middleName }}
      </ui-form-item>

      <ui-form-item label="Last Name">
        {{ model.contact.lastName }}
      </ui-form-item>

      <ui-form-item label="Title/Affiliation with Business">
        {{ model.contact.title }}
      </ui-form-item>

      <br>
      <ui-form-item label="Drivers License Number">
        {{ model.contact.driversLicense.number }}
      </ui-form-item>

      <ui-form-item label="Issuing State">
        {{ model.contact.driversLicense.state }}
      </ui-form-item>

      <br>
      <ui-form-item label="Primary Contact Phone Number">
        {{ model.contact.phone.primary }}
      </ui-form-item>

      <ui-form-item label="Cell Phone Number">
        {{ model.contact.phone.cell }}
      </ui-form-item>

      <ui-form-item label="Email">
        {{ model.contact.email }}
      </ui-form-item>

      <template v-if="model.contact.mailingAddress.isDifferentThanService">
        <br>
        <ui-form-item label="Mailing Address if different from Service Address">
          <address-summary :address="model.contact.mailingAddress" />
        </ui-form-item>
      </template>

      <br>
      <ui-form-item label="Does the business own or lease the property?">
        {{ model.contact.ownOrLease }}
      </ui-form-item>

      <template v-if="model.contact.ownOrLease === 'Lease'">
        <ui-form-item label="Landlord Name">
          {{ model.contact.landlord.name }}
        </ui-form-item>
        <ui-form-item label="Landlord Phone">
          {{ model.contact.landlord.phone }}
        </ui-form-item>
      </template>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },

  computed: {
    stateOptions() {
      return stateOptions
    },
  },
}
